/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * manual: target_discharge_date is a literal date. start_of_care / end_of_care: the date is derived from the lead's admission status. Absent on referrals created before this field existed — treat as manual.
 * @export
 */
export const ReferralDateType = {
    Manual: 'manual',
    StartOfCare: 'start_of_care',
    EndOfCare: 'end_of_care',
} as const;
export type ReferralDateType = typeof ReferralDateType[keyof typeof ReferralDateType];


export function instanceOfReferralDateType(value: any): boolean {
    for (const key in ReferralDateType) {
        if (Object.prototype.hasOwnProperty.call(ReferralDateType, key)) {
            if (ReferralDateType[key as keyof typeof ReferralDateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferralDateTypeFromJSON(json: any): ReferralDateType {
    return ReferralDateTypeFromJSONTyped(json, false);
}

export function ReferralDateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralDateType {
    return json as ReferralDateType;
}

export function ReferralDateTypeToJSON(value?: ReferralDateType | null): any {
    return value as any;
}

export function ReferralDateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ReferralDateType {
    return value as ReferralDateType;
}

